import React from 'react';

class SelectFilter extends React.Component {
  constructor(props) {
    super(props);
    this.handleFilterSelect = this.handleFilterSelect.bind(this);
  }

  handleFilterSelect(e) {
    this.props.onFilterSelect(e.target.value);
  }

  render() {
    const filters = ['Africa', 'Americas', 'Asia', 'Europe', 'Oceania'];
    const theme = this.props.theme;
    return (
      theme ?
        <select className="filter ml-4 py-3 px-4 bg-white mt-10 w-1/2 focus:outline-none text-xs shadow-md rounded-md transition-colors duration-300 
        sm:text-lg md:text-xl lg:text-base lg:w-1/4"
          onChange={this.handleFilterSelect}>
          <option defaultValue value="">Filter by region</option>
          {
            filters.map(filter => (
              <option key={filter} value={filter}> {filter} </option>
            ))
          }
        </select> :
        <select className="filter text-white ml-4 py-3 px-4 bg-gray-800 mt-10 w-1/2 focus:outline-none text-xs shadow-md rounded-md transition-colors duration-300 
        sm:text-lg md:text-xl lg:text-base lg:w-1/4"
          onChange={this.handleFilterSelect}>
          <option className="text-gray-400" defaultValue value="">Filter by region</option>
          {
            filters.map(filter => (
              <option className="text-gray-400" key={filter} value={filter}> {filter} </option>
            ))
          }
        </select>
    );
  }
}

export default SelectFilter;
